// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"e0f9e5f7","488":"a83b531d","901":"9b237c56"}[chunkId] + ".chunk.js";
};